<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Headlines ({{ keys.length }}/{{ maxVariables }}):</div>
      </div>
      <div class="row">
        <div class="col-12" *ngFor="let headlineKey of keys">
          <app-block-text
            [type]="'content'"
            [isPlainText]="true"
            [restrictContent]="true"
            (handleOnChange)="onChange($event, headlineKey)"
            (handleVariableRemoval)="variableRemoval($event)"
            [blockData]="block.variables?.[headlineKey] ?? ''"
            [maxLength]="30"
            [placeholder]="headlinePlaceholder"
            [variable]="headlineKey"
            [blockId]="block.blockId"
            [isSubBlockDeletable]="true"
          ></app-block-text>
        </div>
        <div class="col-12 mt-2">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            (click)="add()"
            [disabled]="!canAdd"
          >
            <i class="bi bi-plus-lg"></i> Add Headline
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
